// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.org360-canvas {
  background:
    radial-gradient(circle at 12% 18%, hsl(var(--primary) / 0.06), transparent 30%),
    hsl(var(--card));
  box-shadow:
    inset 0 1px 0 hsl(var(--foreground) / 0.04),
    0 1px 2px hsl(var(--foreground) / 0.05);
}
`, "",{"version":3,"sources":["webpack://./src/components/organisms/org360/org360.css"],"names":[],"mappings":"AAAA;EACE;;oBAEkB;EAClB;;2CAEyC;AAC3C","sourcesContent":[".org360-canvas {\n  background:\n    radial-gradient(circle at 12% 18%, hsl(var(--primary) / 0.06), transparent 30%),\n    hsl(var(--card));\n  box-shadow:\n    inset 0 1px 0 hsl(var(--foreground) / 0.04),\n    0 1px 2px hsl(var(--foreground) / 0.05);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
